<template>
  <div>
    <ul class="sup_packing">
      <li v-for="(pitem, index) in item.ids" :key="index">
        <el-select size="mini" v-if="pitem.id === 'packing'"  v-model="data[pitem.id]" @change="(item) => handleInput(item, pitem.id, data)">
          <el-option v-for="v in opts" :key="v.id" :label="v.name" :value="v.id"></el-option>
        </el-select>
        <el-autocomplete
          :style="pitem.style"
          size="mini"
          popper-class="autocomplete"
          v-model="data[pitem.id]"
          :fetch-suggestions="(queryString, cb) => querySearch(queryString, cb, pitem)"
          :placeholder="$t(pitem.name)"
          :trigger-on-focus="item.trigger || false"
          @select="(item) => handleSelect(item, pitem.id, data)"
          @input="(item) => handleInput(item, pitem.id, data)"
          v-else
        ></el-autocomplete>
        
      </li>
    </ul>
  </div>
</template>
<script type="text/javascript">
export default {
  name: "SupPacking",
  props: {
    data: {
      type: Object,
      default: () => {
        return {};
      },
    },
    item: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      opts: []
    }
  },
  created() {
    this.getPacking()
  },
  methods: {
    getPacking() {
      this.$axios.$post("rest/portal/product/v3/formatdetails/lookup", {type: 'packing'}).then(({ code, data }) => {
        if (code !== 200) return;
        this.opts = data.map((ele) => {
            ele.id = ele.name;
            ele.name = ele.name
            return ele;
          });
      });
    },
    querySearch(queryString, cb, pitem) {
      let postUrl ="rest/portal/product/v3/formatdetails/lookup";
      let params = {};
      let type =
        pitem.id === "packing" ? "packing":  pitem.id === "moq"
          ? "moq":  pitem.id === "mpq"
          ? "mpq":""
      params = { type: type, value: queryString };
      
      this.$axios.$post(postUrl, params).then(({ code, data }) => {
        if (code !== 200) return;
        let spuList = [];
        if (data) {
          spuList = data.map((ele) => {
            ele.value = ele.name;
            return ele;
          });
        }
        cb(spuList);
      });
    },
    handleSelect(selected, id, row) {
      this.$set(row,id,selected.name)
    },
    handleInput(value, id,row) {
      this.$emit("getValue", {
        id,value,row
      });
    },
  },
};
</script>
<style lang="less">
.sup_packing {
  display: flex;
}
</style>
